import React, { useContext, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { UserContext } from '../../contexts/UserContext';
import { addDealer } from '../../services/DealerService';
import { createTenant } from '../../services/tenantsService';
import { showConfirmationAlert, showDefaultAlert } from '../../utils/alerts';

const DealerModel = ({ closeModel, setDealerData }) => {

  const { token } = useContext(UserContext);
  const [show, setShow] = useState(true);
  const [companyName, setCompanyName] = useState('');
  const [traderNumber, setTraderNumber] = useState('');
  const [enableDealerWeb, setEnableDealerWeb] = useState(false);
  var traderRegex = /^[A-Z]\d{6}$/;

  const handleClose = () => {
    setShow(false);
    closeModel(false);
  };

  const handleEnableDealerWebChange = (event) => {
    const isEnabled = event.target.checked;
    setEnableDealerWeb(isEnabled);
  };

  const handleSubmit = async () => {

    if (!traderRegex.test(traderNumber)) {
      showDefaultAlert('error', 'Error', 'Invalid trader number');
      return;
    }

    const confirmationMessage = 'Are you sure you want to add the new Dealer member?';

    showConfirmationAlert({
      confirmationMessage,
      onConfirm: async () => {
        try {
          const dealerCompanyName = companyName.trim();
          const response = await addDealer(dealerCompanyName, traderNumber, enableDealerWeb, token);
          if (response.status === 200 || response.status === 201) {
            let isTenantCreated = false;
            const dealerID = response?.data?.DealerID;

            if (enableDealerWeb) {
              try {
                if (!dealerID) {
                  throw new Error('DealerID missing in dealer response');
                }
                const tenantResponse = await createTenant(dealerCompanyName, 'Active', dealerID, token);
                isTenantCreated = tenantResponse.status === 200 || tenantResponse.status === 201;
              } catch (tenantError) {
                isTenantCreated = false;
              }
            }

            if (enableDealerWeb && !isTenantCreated) {
              showDefaultAlert('warning', 'Partial Success', 'Dealer was added, but tenant creation failed. Please add the tenant manually.');
            } else if (enableDealerWeb) {
              showDefaultAlert('success', 'Success', 'Successfully added the dealer and tenant.');
            } else {
              showDefaultAlert('success', 'Success', 'Successfully Added the Dealer.');
            }

            setDealerData((prevDealerData) => {
              return [...prevDealerData, response.data];
            });
          }
          handleClose();
        } catch (error) {
          if (error.response && error.response.status === 400) {
            if (error.response.data === "This Dealer company exists.") {
              showDefaultAlert('error', 'Error', 'This Dealer company exists.');
            }
            else if (error.response.data === "Invalid request parameters") {
              showDefaultAlert('error', 'Error', 'Invalid request parameters');
            } else {
              showDefaultAlert('error', 'Error', 'An error occurred. Please try again later.');
            }
          } else {
            showDefaultAlert('error', 'Error', 'An error occurred. Please try again later.');
          }
          handleClose();
        }
      },
    });
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} className="dealer-modal" dialogClassName="dealer-modal__dialog">
        <Modal.Header closeButton >
          <Modal.Title>Add Dealer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3 d-flex dealer-form-row" controlId="dealerCompanyName">
              <Form.Label className="dealer-form-label">Company Name</Form.Label>
              <Form.Control className="dealer-form-control" type="text" placeholder="Enter Company Name" onChange={(e) => setCompanyName(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3 d-flex dealer-form-row" controlId="dealerTraderNumber">
              <Form.Label className="dealer-form-label">Trader Number</Form.Label>
              <Form.Control className="dealer-form-control" type="text" placeholder="Enter Trader Number" onChange={(e) => setTraderNumber(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3 d-flex dealer-form-row dealer-form-switch-row" controlId="dealerEnableWeb">
              <Form.Label className="dealer-form-label">Enable Dealer Web</Form.Label>
              <Form.Check
                className="dealer-form-switch"
                type="switch"
                checked={enableDealerWeb}
                onChange={handleEnableDealerWebChange}
              />
            </Form.Group>
            {/* <Form.Group className="mb- d-flex" controlId="exampleForm.ControlInput1">
              <Form.Label style={{ color: 'black' }} >Logo URL</Form.Label>
              <Form.Control type="text" placeholder="Enter Logo URL" onChange={(e) => setLogoURL(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb- d-flex" controlId="exampleForm.ControlInput1">
              <Form.Label style={{ color: 'black' }} >Trading Name</Form.Label>
              <Form.Control type="text" placeholder="Enter Trading Name" onChange={(e) => setTradingName(e.target.value)} />
            </Form.Group> */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Add Dealer
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DealerModel;
